module.exports = __webpack_public_path__ + "images/a923d2e0f4c8af54cade8311e1f0e947.png";